import OuvidoriaService from '@/services/OuvidoriaService'

export const ouvidoria = {
  namespaced: true,
  actions: {
    topServicosOuvidoriaPorRegiao ({ dispatch }, { top, intervalo, ordenacao, filtroId }) {
      return OuvidoriaService.topServicosOuvidoriaPorRegiao({ top, intervalo, ordenacao, filtroId })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    servicosNaoGeorreferenciadosOuvidoria ({ dispatch }, { top, intervalo, ordenacao }) {
      return OuvidoriaService.servicosNaoGeorreferenciadosOuvidoria({ top, intervalo, ordenacao })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    solicitacoesOuvidoria ({ dispatch }, { top, intervalo, ordenacao }) {
      return OuvidoriaService.solicitacoesOuvidoria({ top, intervalo, ordenacao })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    topServicosOuvidoriaConsolidados ({ dispatch }, { top, intervalo, ordenacao }) {
      return OuvidoriaService.topServicosOuvidoriaConsolidados({ top, intervalo, ordenacao })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    topAssuntosDemandadosOuvidoria ({ dispatch }, { intervalo }) {
      return OuvidoriaService.topAssuntosDemandadosOuvidoria({ intervalo })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    topTemasDemandadosOuvidoria ({ dispatch }, { intervalo }) {
      return OuvidoriaService.topTemasDemandadosOuvidoria({ intervalo })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    topServicosOuvidoriaPorOrgao ({ dispatch }, { top, intervalo, ordenacao, filtroId }) {
      return OuvidoriaService.topServicosOuvidoriaPorOrgao({ top, intervalo, ordenacao, filtroId })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    solicitacoesOuvidoriaConsolidado ({ dispatch }) {
      return OuvidoriaService.solicitacoesOuvidoriaConsolidado()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
  },
}
